export const AD_NETWORK = '7449';
export const AD_MESSAGE_DATA = 'collapse ad';
export const NAV_AD_TYPE = 'nav';
export const DISPLAY_AD_TYPE = 'display';
export const AD_MESSAGE_ORIGIN = /^https:\/\/[a-zA-Z0-9]+\.safeframe\.googlesyndication\.com$/;

export const RENTAL_SECOND_AD_VERS = 'srp_2nd_a';
export const DEFAULT_VERS = 'z_srp_web_state_machine-control';
export const VELOCITY_CONTROL_VERS = 'z_srp_web_velocity-control';

export const DISPLAY_AD_RENDER_EVENT = 'search page display ad first display';

export const NAV_AD_RENDER_EVENT = 'search page nav ad first display';

export const FOR_SALE_ID = 'isForSale';
export const FOR_RENT_ID = 'isForRent';
export const RECENTLY_SOLD_ID = 'isRecentlySold';

export const FOR_SALE_BY_AGENT = 'isForSaleByAgent';
export const FOR_SALE_BY_OWNER = 'isForSaleByOwner';
export const FOR_SALE_NEW_CONSTRUCTION = 'isNewConstruction';
export const FOR_SALE_COMING_SOON = 'isComingSoon';
export const FOR_SALE_AUCTION = 'isAuction';
export const FOR_SALE_FORECLOSURE = 'isForSaleForeclosure';

export const FOR_SALE_PREMARKET_FORECLOSURE = 'isPreMarketForeclosure';
export const FOR_SALE_PREMARKET_PREFORECLOSURE = 'isPreMarketPreForeclosure';

export const FOR_SALE_SUBCATEGORY_IDS = [
    FOR_SALE_BY_AGENT,
    FOR_SALE_BY_OWNER,
    FOR_SALE_NEW_CONSTRUCTION,
    FOR_SALE_COMING_SOON,
    FOR_SALE_AUCTION,
    FOR_SALE_FORECLOSURE,
];

export const POTENTIAL_SUBCATEGORY_IDS = [
    FOR_SALE_PREMARKET_FORECLOSURE,
    FOR_SALE_PREMARKET_PREFORECLOSURE,
];

export const FOR_SALE_AND_PREMARKET_SUBCATEGORY_IDS = [
    ...FOR_SALE_SUBCATEGORY_IDS,
    ...POTENTIAL_SUBCATEGORY_IDS,
];
